import { INutritionalInformation, MetricToImperialConverter } from 'fitbeat.models';
import React, { Component } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale, scaleText } from '../../utils/scaling';
import { isSmall, selectBasedOnScreenWidth } from '../../utils/ScreenSizes';

type PlaceholderTypeWhenConvertedToTsx = any;

interface IProps {
  meal: INutritionalInformation;
  customMainContainerStyle: PlaceholderTypeWhenConvertedToTsx;
  layoutStyle: 'meals' | 'days';
}

function getFlexGrowSizeForLargerEnergyColumn() {
  return selectBasedOnScreenWidth({
    380: 1.6,
    400: 1.5,
    fallback: 1.4,
  });
}

class MealDetailMacros extends Component<IProps> {
  public render() {
    const { meal, customMainContainerStyle, layoutStyle } = this.props;
    const labelStyle = layoutStyle === 'days' ? { color: Theme.DARK_CHARCOAL, alignSelf: 'flex-start' } : {};
    const valueStyle = layoutStyle === 'days' ? { alignSelf: 'flex-start' } : {};
    const borderStyle = layoutStyle === 'meals' ? {} : {
      borderLeftColor: Theme.GREY_MEDIUM_LIGHT,
      paddingLeft: defaultScale(10),
    };
    const leadingSeparator = layoutStyle === 'meals' ? { borderLeftWidth: 0 } : {};
    const largerEnergyColumn = (layoutStyle === 'meals' || !isSmall) ? {} : {
      flexGrow: getFlexGrowSizeForLargerEnergyColumn(),
      paddingRight: defaultScale(10),
    };

    return (
      <View style={[styles.mealCountDetails, customMainContainerStyle]}>
        <View style={[styles.countDetailItem, styles.lineSeparator, borderStyle, leadingSeparator, largerEnergyColumn]}>
          <Text numberOfLines={1} style={[styles.countItemNum, valueStyle]}>
            {meal.calories ? Math.round(meal.calories) : '-'}
            Cals
          </Text>
          <Text style={[styles.countItemLabel, labelStyle]}>
            {meal.calories ? Math.round(MetricToImperialConverter.convertAmount('cals', 'kj', meal.calories)) : '-'}
            kJ
          </Text>
        </View>
        <View style={[styles.countDetailItem, styles.lineSeparator, borderStyle]}>
          <Text style={[styles.countItemNum, valueStyle]}>
            {meal.fat ? Math.round(meal.fat) : '-'}
            g
          </Text>
          <Text style={[styles.countItemLabel, labelStyle]}>Fat</Text>
        </View>
        <View style={[styles.countDetailItem, styles.lineSeparator, borderStyle]}>
          <Text style={[styles.countItemNum, valueStyle]}>
            {meal.carbs ? Math.round(meal.carbs) : '-'}
            g
          </Text>
          <Text style={[styles.countItemLabel, labelStyle]}>Carbs</Text>
        </View>
        <View style={[styles.countDetailItem, styles.lineSeparator, borderStyle]}>
          <Text style={[styles.countItemNum, valueStyle]}>
            {meal.protein ? Math.round(meal.protein) : '-'}
            g
          </Text>
          <Text style={[styles.countItemLabel, labelStyle]}>Protein</Text>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  mealCountDetails: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    paddingVertical: defaultScale(8),
    flex: 4,
  },
  countDetailItem: {
    flex: 1,
  },
  lineSeparator: {
    borderLeftWidth: 1,
    borderLeftColor: Theme.GREY_LIGHT,
  },
  countItemNum: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.DARK_CHARCOAL,
    alignSelf: 'center',
  },
  countItemLabel: {
    ...Theme.textStyle.small,
    fontSize: scaleText(12),
    color: Theme.GREY_MEDIUM,
    alignSelf: 'center',
  },
});

export default MealDetailMacros;
